import { render, staticRenderFns } from "./science.vue?vue&type=template&id=2be10eb2&scoped=true&"
import script from "./science.vue?vue&type=script&lang=js&"
export * from "./science.vue?vue&type=script&lang=js&"
import style0 from "./science.vue?vue&type=style&index=0&id=2be10eb2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2be10eb2",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ScienceHeader: require('/home/runner/work/webpage/webpage/components/science/header/header.vue').default,ScienceLogos: require('/home/runner/work/webpage/webpage/components/science/logos/logos.vue').default,ScienceOurTests: require('/home/runner/work/webpage/webpage/components/science/our-tests/our-tests.vue').default,ScienceOurLabs: require('/home/runner/work/webpage/webpage/components/science/our-labs/our-labs.vue').default,ScienceQualityStandards: require('/home/runner/work/webpage/webpage/components/science/quality-standards/quality-standards.vue').default,ScienceScores: require('/home/runner/work/webpage/webpage/components/science/scores/scores.vue').default,ScienceOurMedicalExperts: require('/home/runner/work/webpage/webpage/components/science/our-medical-experts/our-medical-experts.vue').default,ScienceQuiz: require('/home/runner/work/webpage/webpage/components/science/quiz/quiz.vue').default,AreaFaqs: require('/home/runner/work/webpage/webpage/components/area/faqs/faqs.vue').default})
